{
    "SymbolLabel": "Symbole :",
    "SymbolNote": "(Applique automatiquement les changements aux champs ci-dessous)",
    "PatternLabel": "Motif :",
    "GroupingseparatorLabel": "Séparateur de groupe :",
    "GroupingseparatorOptionCommaDesc": "(Virgule)",
    "GroupingseparatorOptionSpaceDesc": "(Espace)",
    "GroupingseparatorOptionFullstopDesc": "(Arrêt complet)",
    "DecimalseparatorLabel": "Séparateur décimal :",
    "DecimalseparatorOptionFullstopDesc": "(Arrêt complet)",
    "DecimalseparatorOptionColonDesc": "(Colon)",
    "DecimalseparatorOptionCommaDesc": "(Virgule)",
    "PreviewLabel": "Prévisualisation",
    "CurrencyDisplayFormat_SectionHeader": "Format d'affichage des devises",
    "NAME": "CurrencyDisplayFormat"
}